import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const fetchBotsKpi = async (user, startDate, endDate) => {
    try {
        const { data } = await axios.get(`${API_BASE_URL}/bots/kpi?startDate=${startDate}&endDate=${endDate}`, buildHeaders(user))
        return data
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const fetchBotDetailedKpi = async (user, bot_id, startDate, endDate, page, limit) => {
    try {
        const params = `startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`
        const { data } = await axios.get(`${API_BASE_URL}/bots/${bot_id}/kpi?${params}`, buildHeaders(user))
        return data
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const fetchBotUserTransactions = async (user, bot_id, user_uuid, startDate, endDate, page, limit) => {
    try {
        const params = `startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`
        const { data } = await axios.get(`${API_BASE_URL}/bots/${bot_id}/user/${user_uuid}/transactions?${params}`, buildHeaders(user))
        return data
    } catch (error) {
        console.error(error)
        throw error
    }
}

